var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Grid } from '@material-ui/core';
import { Panel } from '@michelin/acid-components';
import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
import { useForm, } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormField } from '../Form/FormField';
import { useUFOVehicleDetailsFormContext } from './UFOVehicleDetailsFormContext';
import { UFOVehicleDetailsKey } from './types';
var FormComponent = function (props, ref) {
    var onSubmit = props.onSubmit, onValidationFailed = props.onValidationFailed, readOnly = props.readOnly, mode = props.mode, onDirtyStateChanged = props.onDirtyStateChanged, getTireSize = props.getTireSize, getCustomTireSize = props.getCustomTireSize, hideDetails = props.hideDetails, optionalTireSizes = props.optionalTireSizes, defaultValues = props.defaultValues;
    var _a = useUFOVehicleDetailsFormContext(), values = _a.values, load = _a.load, loading = _a.loading;
    var t = useTranslation().t;
    // Remap the null or undefined to empty string
    if (defaultValues)
        Object.keys(defaultValues).forEach(function (key) { var _a; defaultValues[key] = (_a = defaultValues[key]) !== null && _a !== void 0 ? _a : ''; });
    var _b = useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
    }), register = _b.register, _c = _b.formState, errors = _c.errors, isDirty = _c.isDirty, handleSubmit = _b.handleSubmit, control = _b.control, reset = _b.reset, watch = _b.watch, setValue = _b.setValue;
    var tireSize = watch('tire_size_id');
    var speedRating = watch('speed_rating');
    var model = watch('model_id');
    var option = watch('option_id');
    var make = watch('make_id');
    var vin = watch('vin');
    var _d = useState(defaultValues), formData = _d[0], setFormData = _d[1];
    if (option === 'unknown' || model === 'unknown' || make === 'unknown') {
        if (tireSize !== 'custom' && tireSize !== 'unknown') {
            setValue('tire_size_id', 'custom');
        }
    }
    if (make === 'unknown') {
        if (model && model !== 'unknown') {
            setValue('model_id', null);
        }
    }
    if (model === 'unknown') {
        if (option && option !== 'unknown') {
            setValue('option_id', null);
        }
    }
    if (!tireSize && getCustomTireSize)
        setValue('tire_size_id', 'custom');
    var areUnknownValues = function () { return make === 'unknown' || option === 'unknown' || model === 'unknown'; };
    var onValid = function (data) {
        var _a, _b, _c, _d, _e, _f;
        if (!readOnly && onSubmit) {
            var vehicle_1 = data;
            var makeInformation = (_a = values.makes.find(function (v) { return v.value === vehicle_1.make_id; })) !== null && _a !== void 0 ? _a : null;
            var fixedData = __assign(__assign({}, data), { custom_tire_size_id: Number(vehicle_1.speed_rating) || null, make_id: (_b = makeInformation === null || makeInformation === void 0 ? void 0 : makeInformation.value) !== null && _b !== void 0 ? _b : null, make_name: (_c = makeInformation === null || makeInformation === void 0 ? void 0 : makeInformation.label) !== null && _c !== void 0 ? _c : null, model_name: (_d = values.models.find(function (v) { return v.value === vehicle_1.model_id; })) === null || _d === void 0 ? void 0 : _d.label, tire_size_id: vehicle_1.model_id && vehicle_1.tire_size_id ? vehicle_1.tire_size_id : null, option_id: vehicle_1.model_id && vehicle_1.option_id ? vehicle_1.option_id : null, model_id: vehicle_1.model_id || null, option_name: vehicle_1.option_id && vehicle_1.model_id ? (_e = values.options.find(function (v) { return v.value === vehicle_1.option_id; })) === null || _e === void 0 ? void 0 : _e.label : null, tire_size_name: vehicle_1.tire_size_id ? (_f = values.tireSizes.find(function (v) { return v.value === vehicle_1.tire_size_id; })) === null || _f === void 0 ? void 0 : _f.label : null });
            if (vehicle_1.tire_size_id === 'unknown') {
                fixedData.tire_size_id = null;
                fixedData.custom_tire_size_id = null;
            }
            if (vehicle_1.model_id === 'unknown') {
                fixedData.model_id = null;
                fixedData.option_id = null;
            }
            if (vehicle_1.option_id === 'unknown') {
                fixedData.option_id = null;
            }
            if (vehicle_1.make_id === 'unknown') {
                fixedData.make_id = null;
            }
            onSubmit(fixedData);
            setFormData(fixedData);
        }
    };
    var onInvalid = function (err) {
        if (!readOnly && onValidationFailed) {
            onValidationFailed(err);
        }
    };
    useImperativeHandle(ref, function () { return ({
        submit: function () {
            handleSubmit(onValid, onInvalid).bind(this)();
        },
        reset: function () {
            reset(formData);
        },
    }); });
    useEffect(function () {
        if (getTireSize && tireSize) {
            getTireSize(tireSize);
        }
    }, [tireSize]);
    useEffect(function () {
        if (getCustomTireSize && speedRating) {
            getCustomTireSize(speedRating);
        }
    }, [speedRating]);
    useEffect(function () {
        if (onDirtyStateChanged) {
            onDirtyStateChanged(isDirty);
        }
    }, [isDirty]);
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Panel, { title: getCustomTireSize ? t('Search by Custom Tire Sizes') : t('Vehicle Information'), style: { marginBottom: 16 } },
                !getCustomTireSize && (React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.year,
                                label: t('Year'),
                                options: values.years,
                                loading: loading.years,
                                helperText: t('Year is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.year], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.make,
                                label: t('Make'),
                                options: values.makes,
                                loading: loading.makes,
                                helperText: t('Make is required'),
                                dependencies: [UFOVehicleDetailsKey.year],
                                onDependenciesChanged: load.makes,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.make], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.model,
                                label: t('Model'),
                                options: values.models,
                                loading: loading.models,
                                dependencies: [UFOVehicleDetailsKey.year, UFOVehicleDetailsKey.make],
                                onDependenciesChanged: load.models,
                                rules: {
                                    required: false,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.model], readOnly: readOnly || make === 'unknown', register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.option,
                                label: t('Option'),
                                options: values.options,
                                loading: loading.options,
                                helperText: !optionalTireSizes ? t('Option is required') : '',
                                dependencies: [UFOVehicleDetailsKey.year, UFOVehicleDetailsKey.make, UFOVehicleDetailsKey.model],
                                onDependenciesChanged: load.options,
                                rules: {
                                    required: !optionalTireSizes,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.option], readOnly: readOnly || model === 'unknown', register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.tireSize,
                                label: t('Tire Size'),
                                options: values.tireSizes,
                                loading: loading.tireSizes,
                                helperText: !optionalTireSizes ? t('Tire Size is required') : '',
                                dependencies: areUnknownValues()
                                    ? [UFOVehicleDetailsKey.year, UFOVehicleDetailsKey.make]
                                    : [UFOVehicleDetailsKey.year, UFOVehicleDetailsKey.make, UFOVehicleDetailsKey.model, UFOVehicleDetailsKey.option],
                                onDependenciesChanged: areUnknownValues() ? load.loadOnlyCustomOptionTireSize : load.tireSizes,
                                rules: {
                                    required: !optionalTireSizes,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.tireSize], readOnly: readOnly, register: register, control: control })))),
                tireSize !== 'custom'
                    ? null
                    : (React.createElement(Grid, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                            React.createElement(FormField, { definition: {
                                    name: UFOVehicleDetailsKey.customTireSizeSize,
                                    label: t('Tire Size'),
                                    options: values.customTireSizeSizes,
                                    loading: loading.customTireSizeSizes,
                                    helperText: t('Custom Tire Size is required'),
                                    dependencies: [UFOVehicleDetailsKey.tireSize],
                                    onDependenciesChanged: load.customTireSizeSizes,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[UFOVehicleDetailsKey.customTireSizeSize], readOnly: readOnly, register: register, control: control })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                            React.createElement(FormField, { definition: {
                                    name: UFOVehicleDetailsKey.customTireSizeAspectRatio,
                                    label: t('Aspect Ratio'),
                                    options: values.customTireSizeAspectRatios,
                                    loading: loading.customTireSizeAspectRatios,
                                    helperText: t('Aspect Ratio is required'),
                                    dependencies: [UFOVehicleDetailsKey.tireSize, UFOVehicleDetailsKey.customTireSizeSize],
                                    onDependenciesChanged: load.customTireSizeAspectRatios,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[UFOVehicleDetailsKey.customTireSizeAspectRatio], readOnly: readOnly, register: register, control: control })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                            React.createElement(FormField, { definition: {
                                    name: UFOVehicleDetailsKey.customTireSizeDiameter,
                                    label: t('Diameter'),
                                    options: values.customTireSizeDiameters,
                                    loading: loading.customTireSizeDiameters,
                                    helperText: t('Diameter is required'),
                                    dependencies: [UFOVehicleDetailsKey.tireSize, UFOVehicleDetailsKey.customTireSizeSize, UFOVehicleDetailsKey.customTireSizeAspectRatio],
                                    onDependenciesChanged: load.customTireSizeDiameters,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[UFOVehicleDetailsKey.customTireSizeDiameter], readOnly: readOnly, register: register, control: control })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                            React.createElement(FormField, { definition: {
                                    name: UFOVehicleDetailsKey.customTireSizeLoad,
                                    label: t('Load'),
                                    options: values.customTireSizeLoads,
                                    loading: loading.customTireSizeLoads,
                                    helperText: t('Load is required'),
                                    // eslint-disable-next-line max-len
                                    dependencies: [UFOVehicleDetailsKey.tireSize, UFOVehicleDetailsKey.customTireSizeSize, UFOVehicleDetailsKey.customTireSizeAspectRatio, UFOVehicleDetailsKey.customTireSizeDiameter],
                                    onDependenciesChanged: load.customTireSizeLoads,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[UFOVehicleDetailsKey.customTireSizeLoad], readOnly: readOnly, register: register, control: control })),
                        React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                            React.createElement(FormField, { definition: {
                                    name: UFOVehicleDetailsKey.customTireSizeSpeedRating,
                                    label: t('Speed Rating'),
                                    options: values.customTireSizeSpeedRatings,
                                    loading: loading.customTireSizeSpeedRatings,
                                    helperText: t('Speed Rating is required'),
                                    // eslint-disable-next-line max-len
                                    dependencies: [UFOVehicleDetailsKey.tireSize, UFOVehicleDetailsKey.customTireSizeSize, UFOVehicleDetailsKey.customTireSizeAspectRatio, UFOVehicleDetailsKey.customTireSizeDiameter, UFOVehicleDetailsKey.customTireSizeLoad],
                                    onDependenciesChanged: load.customTireSizeSpeedRatings,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[UFOVehicleDetailsKey.customTireSizeSpeedRating], readOnly: readOnly, register: register, control: control })))))),
        !hideDetails && !getCustomTireSize && !getTireSize && (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Panel, { title: t('Vehicle Details'), style: { marginBottom: 16 } },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.vehicleUnitNumber,
                                label: t('Vehicle Unit Number'),
                                helperText: t('Vehicle Unit Number is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.vehicleUnitNumber], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, onBlur: function () { return setValue('vin', vin.toString().toLocaleUpperCase()); } },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.vin,
                                label: t('VIN'),
                                helperText: t('VIN is required and should be 17 characters long'),
                                rules: {
                                    required: true,
                                    minLength: 17,
                                    maxLength: 17,
                                },
                                forceUppercase: true,
                            }, error: !!errors[UFOVehicleDetailsKey.vin], readOnly: readOnly || mode === 'edit', register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.licensePlate,
                                label: t('License Plate Number'),
                                helperText: t('License Plate Number is required and should be 7 characters or shorter'),
                                rules: {
                                    required: true,
                                    maxLength: 7,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.licensePlate], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.licenseState,
                                label: t('License Plate State'),
                                helperText: t('License Plate State is required'),
                                options: values.states,
                                loading: loading.states,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.licenseState], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        React.createElement(FormField, { definition: {
                                name: UFOVehicleDetailsKey.color,
                                label: t('Color'),
                                rules: {
                                    required: false,
                                },
                            }, error: !!errors[UFOVehicleDetailsKey.color], readOnly: readOnly, register: register, control: control }))))))));
};
var UFOForm = forwardRef(FormComponent);
export { UFOForm };
//# sourceMappingURL=Form.js.map